import { Projeto } from "../projeto";

export class FiltroAtividade {
    descricao: string;
    dataInicio: Date;
    dataFim: Date;
    projeto: Projeto;
    area: string;
}